const textFieldModalFilter = {
  action: 'Acción',
  problem: 'Problema',
};

export default textFieldModalFilter;
